import { useAppScopeStore } from '@frontend/scope';
import { PaymentSettingsGroup } from '../atoms/payment-settings-group';
import { PaymentSettingsCard } from '../atoms/payments-card';
import { CareCreditSection } from '../sections/care-credit-section';

export const CareCreditGroup = () => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  return (
    <section>
      {locationIds.length === 1 ? (
        <PaymentSettingsCard locationId={locationIds[0]}>
          <CareCreditSection />
        </PaymentSettingsCard>
      ) : (
        <PaymentSettingsGroup showManageAllToggle>
          <CareCreditSection />
        </PaymentSettingsGroup>
      )}
    </section>
  );
};
